(() => {
  if (customElements.get('lgd-arrival')) return;
  const notices = new Set();
  const nzDate = () => {
    const parts = new Intl.DateTimeFormat('en-NZ', {timeZone: 'Pacific/Auckland', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(new Date());
    const value = name => parts.find(part => part.type === name).value;
    return `${value('year')}-${value('month')}-${value('day')}`;
  };
  class ArrivalNotice extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-lgd-arrival-variants]').textContent);
      } catch { return; }
      this.message = this.querySelector('[data-lgd-arrival-message]');
      this.fallback = this.querySelector('[data-lgd-arrival-fallback]');
      this.label = this.querySelector('[data-lgd-arrival-label]');
      this.time = this.querySelector('[data-lgd-arrival-date]');
      notices.add(this);
      this.refresh();
    }
    disconnectedCallback() { notices.delete(this); }
    refresh() {
      const today = nzDate();
      let date = '';
      let some = false;
      if (this.dataset.mode === 'card') {
        const pending = this.variants.filter(variant => variant.date && variant.date >= today);
        date = pending.map(variant => variant.date).sort()[0] || '';
        some = pending.length < this.variants.length;
      } else {
        const form = document.getElementById(`product-form-${this.dataset.product}`);
        const selected = form?.querySelector('[name="id"]')?.value || this.dataset.selected;
        const variant = this.variants.find(item => String(item.id) === String(selected));
        if (variant?.date && variant.date >= today) date = variant.date;
      }
      this.message.hidden = !date;
      this.fallback.hidden = Boolean(date);
      if (this.dataset.mode === 'detail') {
        this.closest('.productView')?.querySelectorAll('[data-inventory], pickup-availability').forEach(item => { item.hidden = Boolean(date); });
      }
      if (!date) return;
      this.label.textContent = some ? this.dataset.some : this.dataset.coming;
      this.time.dateTime = date;
      const style = this.dataset.mode === 'card' ? {day:'numeric', month:'short'} : {day:'numeric', month:'long', year:'numeric'};
      let locale = this.dataset.locale || 'en-NZ';
      if (locale === 'en') locale = 'en-NZ';
      this.time.textContent = new Intl.DateTimeFormat(locale, {...style, timeZone:'Pacific/Auckland'}).format(new Date(`${date}T12:00:00+13:00`));
    }
  }
  customElements.define('lgd-arrival', ArrivalNotice);
  let queued;
  const refresh = () => notices.forEach(notice => notice.refresh());
  document.addEventListener('change', event => {
    if (!event.target.matches('[name="id"], .product-form__radio, .single-option-selector, [data-product-option]') && !event.target.closest('.productView-options')) return;
    clearTimeout(queued);
    queued = setTimeout(refresh, 0);
  });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  setInterval(refresh, 30000);
})();
